import { Injectable } from '@angular/core';
import { Observable , of} from 'rxjs';
import { EformDuplicableEntityService } from './eform-duplicable-entity.service';

/**
 * Service responsable du chargement des données d'avis depuis le backend.
 * Gère la récupération des avis en fonction de l'ID courant stocké dans EformDuplicableEntityService.
 */
@Injectable({
  providedIn: 'root'
})
export class AvisDataLoaderService {
  constructor(private eformDuplicableEntityService: EformDuplicableEntityService) {}

/**
 * Récupère les données complètes d'un avis depuis le backend.
 * Vérifie d'abord si un ID d'avis est disponible avant de faire l'appel.
 *
 * @returns Observable<any> Retourne :
 * - Les données de l'avis si un ID est disponible
 * - null si aucun ID n'est défini
 **/
  getCompleteAvisWithCurrentId(): Observable<any> {
    const currentId = this.eformDuplicableEntityService.currentAvisId.getValue();
    return currentId ? this.eformDuplicableEntityService.getAvis(currentId) : of(null);
  }
}
